<template>
	<div class="container data_governance_page">
		<!-- 顶部 -->
		<PageTop></PageTop>
		<!-- 顶部 end -->

		<div style="display: flex;position: relative;width: 100%;height: 100%;background: #fff;">
			<!-- 侧边导航 -->
			<SideNavigation></SideNavigation>
			<!-- 侧边导航 end -->

			<!-- 子路由页面 -->
			<router-view></router-view>
			<!-- 子路由页面 end -->
		</div>

	</div>
</template>

<script>
	import PageTop from "./components/page_top.vue";
	import SideNavigation from "./components/side_navigation.vue";

	export default {
		components: {
			PageTop,
			SideNavigation
		}
	}
</script>

<style scoped>
	.data_governance_page{ padding: 60px 0 0 0; }
</style>
